export default __webpack_public_path__ + "static/media/hardware.5876f46b.svg";